/* Alkemix スクロールフェードイン（全 alkemix- セクション自動適用） */
(function () {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
  
    // alkemix- で始まるクラスを持つ全セクションを対象にする
    var sections = document.querySelectorAll('section[class^="alkemix-"], section[class*=" alkemix-"]');
    if (!sections.length) return;
  
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('amx-visible');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -40px 0px'
    });
  
    sections.forEach(function (sec) {
      // 画面内に既にあるセクション（ファーストビュー）は動かさない
      var rect = sec.getBoundingClientRect();
      var inView = rect.top < window.innerHeight && rect.bottom > 0;
      if (inView) return;
  
      sec.classList.add('amx-reveal');
  
      // セクション内のカード・アイテムに時間差を付与
      var children = sec.querySelectorAll('[class*="__card"], [class*="__item"]');
      children.forEach(function (child, i) {
        child.classList.add('amx-reveal-child');
        child.style.transitionDelay = Math.min(i * 90, 540) + 'ms';
      });
  
      observer.observe(sec);
    });
  })();